import type {ComponentPropsWithoutRef} from "react";
import styles from "./ResizeHandle.module.css";

/**
 * Draggable vertical divider between two horizontally-arranged panes. Spread the
 * `separatorProps` from `useResizable` onto it for drag + keyboard resizing.
 */
export const ResizeHandle = ({
    className,
    ...props
}: ComponentPropsWithoutRef<"div">) => (
    <div
        className={className ? `${styles.handle} ${className}` : styles.handle}
        {...props}
    >
        <span className={styles.grip} aria-hidden />
    </div>
);
